import Vue from 'vue'
import Vuex from 'vuex'
import { isProductionBuildType } from '@/environment-detection'

import authentication from '@/modules/authentication/store'
import marketplace from '@/modules/marketplace/store'
import myTransports from '@/modules/my-transports/store'
import myAssignments from '@/modules/my-assignments/store'
import transportRegistration from '@/modules/transport-registration/store'

import * as getters from './getters'
import * as mutations from './mutations'
import * as actions from './actions'

Vue.use(Vuex)

if (!isProductionBuildType()) {
  // We do this here to be able to see the store on Vue Dev Tools
  // https://github.com/vuejs/vue-devtools/issues/405
  Vue.config.devtools = true
}

export const createInitialState = () => ({
  currentUser: null,
  currentUserGroups: [],
  partnerManager: null,
  vehicleTypes: {},
  shouldReload: false,
  teamMembers: [],
  openAssignmentsCount: 0,
  currentCarrierCompany: {},
  isBannerOpen: false
})

export const createInitialStoreObject = () => ({
  state: createInitialState(),
  getters,
  mutations,
  actions,
  modules: {
    authentication,
    marketplace,
    myTransports,
    myAssignments,
    transportRegistration
  }
})

export default new Vuex.Store(createInitialStoreObject()) as any
